<template>
    <div id="internet-offers" class="container-fluid mb-1">
        <div class="row px-1 mb-2">
            <div class="col-12 px-0">
                <h2 class="h3 mb-md-2 mb-1" v-html="internetOffersData.titleHtml" />
            </div>

            <div class="col-12 px-0 mb-2">
                <span v-if="internetOffersData.tagWithoutEquipmentLabel" class="ob1-filterchip pe-2">
                    <input
                        id="tag1"
                        class="ob1-filterchip-input visually-hidden"
                        type="checkbox"
                        :checked="internetOffersFilter != null && !internetOffersFilter"
                        @change="updateFilterEquipment(false)"
                    >
                    <label
                        for="tag1"
                        class="ob1-filterchip-label"
                        v-html="internetOffersData.tagWithoutEquipmentLabel"
                    />
                </span>

                <span v-if="internetOffersData.tagWithEquipmentLabel" class="ob1-filterchip">
                    <input
                        id="tag2"
                        class="ob1-filterchip-input visually-hidden"
                        type="checkbox"
                        :checked="internetOffersFilter != null && internetOffersFilter"
                        @change="updateFilterEquipment(true)"
                    >
                    <label
                        for="tag2"
                        class="ob1-filterchip-label"
                        v-html="internetOffersData.tagWithEquipmentLabel"
                    />
                </span>
            </div>


            <div class="col-12 px-0">
                <!--/* CAROUSEL EN MODE MOBILE ET INVISIBLE EN MODE DESKTOP */-->
                <div class="container mw-100">
                    <div class="row px-0">
                        <div class="col-12 px-0">
                            <swiper-container
                                uniq-swiper-id="internetOffersSwiper1"
                                :slides-per-view="swiperSlidesPerView"
                                :space-between="swiperSpaceBetween"
                                :pagination="swiperPagination"
                                :navigation="swiperNavigation"
                                :update-navigation-position-in-screen="swiperUpdateNavigationPositionInScreen"
                                :padding-bottom-in-px="swiperPaddingBottomInPx"
                                :breakpoints="swiperBreakpoints"
                                @after-swiper-update="afterSwiperUpdate"
                            >
                                <swiper-slide
                                    v-for="(offer, offerIndex) in internetOffersTilesWithUpdatedDetailPageUrl"
                                    :key="offer.id"
                                    :is-initial-swiper-slide="offer.seoId === selectedInternetOfferSeoId"
                                    style="height: auto"
                                >
                                    <new-internet-offer-tile
                                        :key="offer.seoId"
                                        :offer="offer"
                                        :is-selected="offer.seoId === selectedInternetOfferSeoId"
                                        :offer-tile-index="offerIndex"
                                        :show-detail-page="internetOffersData.showOfferDetailPage"
                                        @select-offer="selectOffer"
                                    />
                                </swiper-slide>
                                <swiper-slide
                                    v-for="internetOffersAnimationTile in internetOffersAnimationsTiles"
                                    :key="internetOffersAnimationTile.id"
                                    style="height: auto"
                                >
                                    <internet-push-animation-tile :push-animation="internetOffersAnimationTile" />
                                </swiper-slide>
                            </swiper-container>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="!internetOffersData.eligibilityResult" class="col-12 px-0 pt-1">
                <a
                    :href="internetOffersData.alternateLink.link"
                    :data-oevent-category="internetOffersData.alternateLink.tms.category"
                    :data-oevent-action="internetOffersData.alternateLink.tms.action"
                    :data-oevent-label="internetOffersData.alternateLink.tms.label"
                    class="ob1-link-arrow ob1-link-large"
                    v-html="internetOffersData.alternateLink.label"
                />
            </div>
        </div>
    </div>
</template>

<script>
import SwiperContainer from "../../../../../../common/components/vue/swiper/SwiperContainer.vue";
import SwiperSlide from "../../../../../../common/components/vue/swiper/SwiperSlide.vue";
import NewInternetOfferTile from "../../../../internet/showcase/components/NewInternetOfferTile.vue";
import InternetPushAnimationTile from "../../../../internet/showcase/components/InternetPushAnimationTile.vue";

export default {
    name: "InternetOffers",
    components: {
        InternetPushAnimationTile,
        NewInternetOfferTile,
        SwiperContainer,
        SwiperSlide
    },
    props: {
        internetOffersData: {type: Object, required: true},
        selectedInternetOfferSeoId: {type: String, required: true},
        detailPageQueryParams: {type: Object, required: false, default: undefined},
        showDetailPage: {type: Boolean, required: false},
        internetOffersFilter: {type: Boolean, required: false}
    },
    data() {
        return {
            swiperSlidesPerView: 1.15,
            swiperPagination: false,
            swiperSpaceBetween: 30,
            swiperNavigation: true,
            swiperUpdateNavigationPositionInScreen: true,
            swiperPaddingBottomInPx: 15,
            swiperBreakpointsDisplayingFiveSlidesOrMore: {
                // when window width is >= 560px
                560: {
                    slidesPerView: 1.6
                },
                // when window width is >= 736px
                736: {
                    slidesPerView: 2.5
                },
                // when window width is >= 1050px
                1050: {
                    slidesPerView: 3.2
                },
                // when window width is >= 1280px
                1280: {
                    slidesPerView: 3.5
                }
            },
            swiperBreakpointsDisplayingFourSlides: {
                // when window width is >= 560px
                560: {
                    slidesPerView: 1.6
                },
                // when window width is >= 736px
                736: {
                    slidesPerView: 2.5
                },
                // when window width is >= 1050px
                1050: {
                    slidesPerView: 3.2
                },
                // when window width is >= 1280px
                1280: {
                    slidesPerView: 4
                }
            },
            swiperBreakpointsDisplayingThreeSlides: {
                // when window width is >= 560px
                560: {
                    slidesPerView: 1.6
                },
                // when window width is >= 736px
                736: {
                    // slidesPerView: 1.8
                    slidesPerView: 2.5
                },
                // when window width is >= 960px
                960: {
                    slidesPerView: 3
                }
            },
        }
    },
    computed: {
        internetOffersTiles() {
            if (this.internetOffersData) {
                if (this.internetOffersFilter == null && this.internetOffersData.internetOffersTiles) {
                    return this.internetOffersData.internetOffersTiles;
                } else if (this.internetOffersFilter === true && this.internetOffersData.internetOffersTilesWithEquipment) {
                    return this.internetOffersData.internetOffersTilesWithEquipment;
                } else if (this.internetOffersFilter === false && this.internetOffersData.internetOffersTilesWithoutEquipment) {
                    return this.internetOffersData.internetOffersTilesWithoutEquipment;
                } else {
                    return [];
                }
            } else {
                return [];
            }
        },
        internetOffersTilesWithUpdatedDetailPageUrl() {
            if (this.detailPageQueryParams) {
                return this.internetOffersTiles.map((internetOffersTile) => {
                    const updatedDetailPageUrl = new URL(internetOffersTile.detailPageUrl);

                    updatedDetailPageUrl.searchParams.set('offreInternet', this.detailPageQueryParams.offreInternet);
                    updatedDetailPageUrl.searchParams.set('offreMobile', this.detailPageQueryParams.offreMobile);
                    updatedDetailPageUrl.searchParams.set('vitrineHashTag', this.detailPageQueryParams.vitrineHashTag);

                    return { ...internetOffersTile, detailPageUrl: updatedDetailPageUrl.toString() }
                })
            }
            return this.internetOffersTiles
        },
        internetOffersAnimationsTiles() {
            if (this.internetOffersData) {
                if (this.internetOffersFilter == null && this.internetOffersData.offersAnimationsTiles) {
                    return this.internetOffersData.offersAnimationsTiles;
                } else if (this.internetOffersFilter === true && this.internetOffersData.offersAnimationsTilesWithEquipment) {
                    return this.internetOffersData.offersAnimationsTilesWithEquipment;
                } else if (this.internetOffersFilter === false && this.internetOffersData.offersAnimationsTilesWithoutEquipment) {
                    return this.internetOffersData.offersAnimationsTilesWithoutEquipment;
                } else {
                    return [];
                }
            } else {
                return [];
            }
        },
        swiperBreakpoints() {
            if ((this.internetOffersTiles) && (this.internetOffersTiles.length >= 5)) {
                return this.swiperBreakpointsDisplayingFiveSlidesOrMore;
            } else if (this.internetOffersTiles.length === 4) {
                return this.swiperBreakpointsDisplayingFourSlides;
            } else {
                return this.swiperBreakpointsDisplayingThreeSlides;
            }
        }
    },
    methods: {
        selectOffer(offerSeoId) {
            this.$emit('select-internet-offer-seo-id', offerSeoId);
        },
        afterSwiperUpdate() {
            this.$emit("after-swiper-update")
        },
        updateFilterEquipment(state) {
            if (this.internetOffersFilter === state) {
                this.$emit("update-filter-equipment", null)
            } else {
                this.$emit("update-filter-equipment", state)
            }
        }
    }
}
</script>

<style scoped lang="scss">

// hack hauteur tuiles noires EDITO
.swiper-slide-height {
    height: auto !important;
}

</style>
